import React from 'react';
import styled from 'styled-components';
import { Tooltip as ReactTooltip } from 'react-tooltip';

import { ZoomToRegionIcon } from '../icons/zoomToRegionIcon';
import { PinMarkerIcon } from '../icons/pinMarkerIcon';
import { ZoomInIcon } from '../icons/zoomInIcon';
import { ZoomOutIcon } from '../icons/zoomOutIcon';
import { PanZoomControlType } from '../utilities/interfaces';
import { commonTooltipInlineStyle } from '../utilities/constants';

const enabledBackgroundColor = '#2e98e3';
const disabledBackgroundColor = '#FFFFFF';

const panButtonTooltipId = 'pan-button-tool-tip';
const zoomPickerButtonTooltipId = 'zoom-picker-button-tool-tip';
const zoomInButtonTooltipId = 'zoom-in-button-tool-tip';
const zoomOutButtonTooltipId = 'zoom-out-button-tool-tip';

export const PanZoomControl = ({
    zoomInPressed,
    zoomOutPressed,
    panToMarkerPressed,
    toggleZoomRegionPressed,
    zoomPickerEnabled,
    zoomInButtonEnabled = true,
    zoomOutButtonEnabled = true,
    panToMarkerButtonEnabled = true,
    toggleZoomRegionButtonEnabled = true
}: PanZoomControlType) => {
    return (
        <MapControlContainer id='mapPanZoomControlContainer'>
            <ReactTooltip 
                key={panButtonTooltipId}
                style={commonTooltipInlineStyle} 
                positionStrategy='fixed'
                effect='solid'
                content='Pan to Marker'
                id={panButtonTooltipId} />
            <ReactTooltip 
                key={zoomPickerButtonTooltipId}
                style={commonTooltipInlineStyle} 
                positionStrategy='fixed'
                effect='solid'
                content={zoomPickerEnabled ? '' : 'Zoom Level'}
                id={zoomPickerButtonTooltipId} />
            <ReactTooltip 
                key={zoomInButtonTooltipId}
                style={commonTooltipInlineStyle} 
                positionStrategy='fixed'
                effect='solid'
                content={'Zoom In'}
                id={zoomInButtonTooltipId} />
            <ReactTooltip 
                key={zoomOutButtonTooltipId}
                style={commonTooltipInlineStyle} 
                positionStrategy='fixed'
                effect='solid'
                content={'Zoom Out'}
                id={zoomOutButtonTooltipId} />
            {panToMarkerButtonEnabled && <MapControlBtn id='mapPanButtonContainer'
                key='panButton'
                onClick={panToMarkerPressed}
                data-tooltip-id={panButtonTooltipId}
            >
                <PinMarkerIcon key='mapPanButtonContainerPinMarkerIcon' />
            </MapControlBtn>}
            {toggleZoomRegionButtonEnabled && <MapZoomPickerButtonContainer 
                id='mapZoomPickerButtonContainer'
                key='zoomPickerButton'
                onClick={toggleZoomRegionPressed}
                zoomPickerEnabled={zoomPickerEnabled}
                enabledBackgroundColor={enabledBackgroundColor}
                disabledBackgroundColor={disabledBackgroundColor}
                data-tooltip-id={zoomPickerButtonTooltipId}
            >
                <ZoomToRegionIcon key='zoomToRegionMapZoomPickerButton' color={zoomPickerEnabled ? '#FFFFFF' : '#666666' } />
            </MapZoomPickerButtonContainer>}
            {zoomInButtonEnabled && <MapControlBtn id='mapZoomInButtonContainer'
                key='zoomInButton'
                onClick={zoomInPressed}
                data-tooltip-id={zoomInButtonTooltipId} >
                <ZoomInIcon key='zoomInMapButton'/>
            </MapControlBtn>}
            {zoomOutButtonEnabled && <MapZoomOutButtonContainer id='mapZoomOutButtonContainer'
                key='zoomOutButton'
                onClick={zoomOutPressed}
                data-tooltip-id={zoomInButtonTooltipId}
            >
                <ZoomOutIcon key='zoomOutMapButton'/>
            </MapZoomOutButtonContainer>
            }
        </MapControlContainer>
    );
};

const MapControlContainer = styled.div`
    background-color: white;
    display: flex;
    flex-direction: column;
    margin-left: 5px;
`;

const MapControlBtn = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
    height: 48px;
    width: 48px;
    min-height: 48px;
    cursor: pointer;
    border-bottom: 1px solid #D8D8D8;
    &:hover: {
        background-color: #EEEEEE;
    }
`;

const MapZoomOutButtonContainer = styled(MapControlBtn)`
    border-bottom: 0px;
`;

interface MapZoomPickerButtonContainerProps {
    zoomPickerEnabled: boolean;
    enabledBackgroundColor: string;
    disabledBackgroundColor: string;
}
const MapZoomPickerButtonContainer = styled(MapControlBtn)<MapZoomPickerButtonContainerProps>`
    background-color: ${({ zoomPickerEnabled, enabledBackgroundColor, disabledBackgroundColor }) => zoomPickerEnabled ? enabledBackgroundColor : disabledBackgroundColor};
    &:hover: {
        background-color: ${({ zoomPickerEnabled, enabledBackgroundColor }) => zoomPickerEnabled ? enabledBackgroundColor : '#EEEEEE'};
    }
`;
